// extracted by mini-css-extract-plugin
export var autoExpand = "_47-8";
export var container = "_47-7";
export var containerWidth = "_47-5";
export var disabled = "_47-2";
export var error = "_47-3";
export var fullWidth = "_47-6";
export var inputWrapper = "_47-0";
export var small = "_47-1";
export var textarea = "_47-4";